import { useState, useEffect } from "react";
import apibig from "../components/Apibig";
import autusuario from "../data/configuracion"

const usePermisos = ({ initialForm}) => {
  const [creadenciales, setCredenciales] = useState(autusuario);
  const [roles, setRoles] = useState(initialForm);
  const [errores, setError] = useState(null);
  const [erroresroles, setErroresroles] = useState(null);
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [response, setReponse] = useState({});
  const [itemToDelete, setItemToDelete] = useState(null);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);



  // Cargar roles al montar
  useEffect(() => {
    fetchRoles(); 
  }, [roles]);

  // Obtener roles desde el backend
  const fetchRoles = async () => {
  if (!autusuario?.proyecto|| !autusuario?.basedatos) {
    console.log("No se encontró información de sesión.");
    return;
  }
  try {

    const res = await apibig.post("/api/roles/getroles", {
      appid: creadenciales?.proyecto,
      basedatos: creadenciales?.basedatos,
    });
    setRoles(res.data);
  } catch (err) {
    console.error("Error al obtener roles:", err);
    setError("Error al cargar los roles desde el servidor.");
  } finally {
    setLoading(false);
  }
   setLoading(false);
};

  // Agregar rol (placeholder)
  const handleChange = () => {
    alert("Agregar rol");
  };
  // Agregar rol (placeholder)
  const handleAddRol = () => {
    alert("Agregar rol");
  };

  // Editar rol (placeholder)
  const handleEditRol = (rol) => {
    alert(`Editar rol: ${rol.NombreRol}`);
  };

  // Editar permisos (placeholder)
  const handleEditarPermisos = (permisos) => {
    alert("Editar permisos");
  };

  // Marcar para eliminar
  const handleDeleteRol = (item) => {
    setItemToDelete(item);
    setShowConfirmDelete(true);
  };

  // Confirmar y eliminar rol
  const confirmDeleteRol = () => {
    if (itemToDelete){     
       setShowConfirmDelete(false);
       //setDeleting(true)
       deleteRol(itemToDelete.Id)
      .then(() => {               
       // setRoles((prev) => prev.filter((r) => r.Id !== itemToDelete.Id));
        setItemToDelete(null);
        setShowConfirmDelete(false);
             })
      .catch((err) => {
        console.log("Error eliminando rol:", err);
        setShowConfirmDelete(false);
      });
    }else{    
      return}

  };

  // Llamada a API para eliminar
  const deleteRol = async (id) => {    
    try {
      apibig.post("/api/roles/deleterol", {
        appid: creadenciales?.proyecto,
        basedatos: creadenciales?.basedatos,
        id: id,
      }); 
     
         return true;
    } catch (err) {
      console.error("Error al eliminar rol:", err);
      return false;
    } 
  };

  // Exponer funciones y estados
  return {
    roles,
    errores,
    erroresroles,
    loading,
    deleting,
    showConfirmDelete,
    setShowConfirmDelete,
    itemToDelete,
    confirmDeleteRol,
    handleEditRol,
    handleEditarPermisos,
    handleDeleteRol,
    handleAddRol,
  };
};

export default usePermisos;
